import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface Crumb {
  label: string;
  path?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  const { t } = useTranslation();

  return (
    <nav aria-label="面包屑导航" className="text-sm text-foreground-600">
      <ol className="flex flex-wrap items-center gap-1.5">
        <li>
          <Link to="/" className="flex items-center gap-1 transition hover:text-primary-600">
            <i className="ri-home-4-line" aria-hidden="true"></i>
            <span>{t('cat_breadcrumb_home')}</span>
          </Link>
        </li>
        {items.map((item, idx) => (
          <li key={idx} className="flex items-center gap-1.5">
            <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true"></i>
            {item.path ? (
              <Link to={item.path} className="transition hover:text-primary-600">
                {item.label}
              </Link>
            ) : (
              <span className="font-medium text-foreground-950">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}